import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DepthComponent } from './depth.component';
import { PrecisionModule, NullCheckModule } from '../../pipes';



@NgModule({
    declarations: [
        DepthComponent
    ],
    imports: [
        CommonModule,
        PrecisionModule,
        NullCheckModule
    ],
    exports: [
        DepthComponent
    ]
})
export class DepthModule { }
